import React from 'react';
import { ArrowUpRightIcon } from 'lucide-react';
import { ageLibraries } from '../data/bonuses';
import { SectionHeading } from './SectionHeading';
export function AgeLibraries() {
  const jumpToSearch = () => {
    const el = document.getElementById('search');
    if (el) el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return <section aria-labelledby="ages-heading" id="ages" className="scroll-mt-24" data-id="element-30" data-mp="pyy88j2ypkmu">
      <SectionHeading index="05" title="Or choose by age" note="A second way in, for the afternoon when you do not know where to start. Each library sits alongside the twelve books rather than replacing them." data-id="element-31" data-mp="29cdc7tmhrkn" />

      <div className="mt-8 grid gap-px bg-rule sm:grid-cols-3" data-id="element-32" data-mp="77nmegc3fy1t">
        {ageLibraries.map(lib => <article key={lib.id} className="flex flex-col bg-surface p-6 sm:p-7" data-id="element-33" data-mp="3fnh24sylp5ht">
            <p className="tnum font-display text-[30px] font-semibold leading-none text-gold" data-id="element-34" data-mp="3fle5hq2y0e44">
              {lib.band}
            </p>
            <p className="mt-1 font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-muted" data-id="element-35" data-mp="1mloi0h7wzh90">
              years
            </p>
            <h3 className="mt-4 font-display text-[20px] font-semibold leading-tight text-ink" data-id="element-36" data-mp="1riewj042m4sb">
              {lib.title}
            </h3>
            <p className="mt-2 font-sans text-[14.5px] leading-relaxed text-ink/70" data-id="element-37" data-mp="20cbgq9dod753">{lib.blurb}</p>

            <div className="mt-auto flex flex-wrap gap-2 pt-6" data-id="element-38" data-mp="13mk9d9kabphv">
              <a href={lib.href} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 bg-green px-3.5 py-2.5 font-sans text-[13px] leading-none text-onaccent transition-colors duration-150 ease-out hover:bg-[#33684D] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-39" data-mp="13o587bdmtulj">
                <ArrowUpRightIcon aria-hidden="true" className="h-4 w-4" strokeWidth={1.5} data-id="element-40" data-mp="2t0fp52nmrybh" />
                Open library
              </a>
              {lib.filter.length ? <button type="button" onClick={jumpToSearch} className="inline-flex items-center gap-2 border border-rule px-3.5 py-2.5 font-sans text-[13px] leading-none text-ink transition-colors duration-150 ease-out hover:border-ink/45 hover:bg-ink/[0.05] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ink focus-visible:ring-offset-2 focus-visible:ring-offset-surface" data-id="element-41" data-mp="oxnty3tb5nzb">
                  Projects for this age
                </button> : null}
            </div>
          </article>)}
      </div>
    </section>;
}